<template>
    <div :style="{ display: 'flex' }" v-if="!!items">
        <btn-header
            v-for="(item, index) in items"
            :key="index"
            :icon="item.icon"
            :href="item.link"
            :items="item.childrens"
        ></btn-header>
    </div>
</template>

<script>
export default {
    props: {
        items: {
            type: Array,
            default: null,
            required: true
        }
    }
};
</script>
